(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diversity-virtual-try-on"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const lerp = (from, to, amount) => from + (to - from) * amount;

  document.querySelectorAll('[data-diversity-vto]').forEach((root) => {
    if (root.dataset.vtoReady === 'true') return;
    root.dataset.vtoReady = 'true';

    const dialog = root.querySelector('[data-vto-dialog]');
    const openButton = root.querySelector('[data-vto-open]');
    const closeButton = root.querySelector('[data-vto-close]');
    const video = root.querySelector('[data-vto-video]');
    const garment = root.querySelector('[data-vto-garment]');
    const garmentMesh = root.querySelector('[data-vto-garment-mesh]');
    const bottomRig = root.querySelector('[data-vto-bottom-rig]');
    const bottomWaist = root.querySelector('[data-vto-bottom-waist]');
    const bottomWaistImg = root.querySelector('[data-vto-bottom-waist-img]');
    const bottomLeftWrap = root.querySelector('[data-vto-bottom-left-wrap]');
    const bottomLeftImg = root.querySelector('[data-vto-bottom-left-img]');
    const bottomRightWrap = root.querySelector('[data-vto-bottom-right-wrap]');
    const bottomRightImg = root.querySelector('[data-vto-bottom-right-img]');
    const bottomSkirt = root.querySelector('[data-vto-bottom-skirt]');
    const bottomSkirtImg = root.querySelector('[data-vto-bottom-skirt-img]');
    const occlusion = root.querySelector('[data-vto-occlusion]');
    const status = root.querySelector('[data-vto-status]');
    const scaleInput = root.querySelector('[data-vto-scale]');
    const widthInput = root.querySelector('[data-vto-width]');
    const xInput = root.querySelector('[data-vto-x]');
    const yInput = root.querySelector('[data-vto-y]');
    const flipButton = root.querySelector('[data-vto-flip]');
    const cameraButton = root.querySelector('[data-vto-camera]');
    const captureButton = root.querySelector('[data-vto-capture]');
    const lockButton = root.querySelector('[data-vto-lock]');
    const resetButton = root.querySelector('[data-vto-reset]');
    const stage = root.querySelector('[data-vto-stage]');

    const title = (root.dataset.productTitle || '').toLowerCase();
    const type = (root.dataset.productType || '').toLowerCase();
    const tags = (root.dataset.productTags || '').toLowerCase();
    const garmentText = title + ' ' + type + ' ' + tags;
    const diversitySizeMatch = garmentText.match(/(?:^|[\s,])d(10|[1-9])([+-])?(?:$|[\s,])/);
    const diversitySize = diversitySizeMatch ? Number(diversitySizeMatch[1]) : null;
    const diversityModifier = diversitySizeMatch ? diversitySizeMatch[2] || '' : '';
    const diversityChestRanges = {
      1: [28, 31], 2: [31, 33], 3: [33, 36], 4: [36, 39], 5: [39, 42],
      6: [42, 45], 7: [45, 48], 8: [48, 52], 9: [52, 56], 10: [56, 60]
    };
    const diversityChest = diversitySize
      ? diversityModifier === '-'
        ? diversityChestRanges[diversitySize][0]
        : diversityModifier === '+'
          ? diversityChestRanges[diversitySize][1]
          : (diversityChestRanges[diversitySize][0] + diversityChestRanges[diversitySize][1]) / 2
      : null;
    const explicitGarmentText = title + ' ' + type;
    const classifyGarment = (primaryText, fallbackText) => {
      const classify = (text) =>
        /jumpsuit|romper|coverall|overall/.test(text) ? 'one-piece' :
        /dress|gown|kaftan|caftan/.test(text) ? 'dress' :
        /(?:^|\s|-)skirt(?:\s|-|$)/.test(text) ? 'skirt' :
        /(?:^|\s|-)shorts?(?:\s|-|$)/.test(text) ? 'shorts' :
        /pants|trouser|jean|legging|jogger|chino/.test(text) ? 'pants' :
        /coat|jacket|blazer|cardigan|overshirt|shacket/.test(text) ? 'outerwear' :
        /hoodie|sweater|sweatshirt|pullover/.test(text) ? 'layer' :
        /tank\b|camisole|cami\b|vest\b|halter|sleeveless/.test(text) ? 'sleeveless-top' :
        /tee\b|t-shirt|t shirt|polo\b|shirt\b|top\b|blouse/.test(text) ? 'top' :
        null;
      return classify(primaryText) || classify(fallbackText) || 'top';
    };
    const garmentClass = classifyGarment(explicitGarmentText, tags);
    const mode =
      /pants|shorts|skirt/.test(garmentClass) ? 'bottom' :
      /dress|one-piece/.test(garmentClass) ? 'long' :
      'top';
    const bottomType =
      garmentClass === 'skirt' ? 'skirt' :
      garmentClass === 'shorts' ? 'shorts' :
      'pants';
    const sleeveType =
      mode !== 'top' ? 'none' :
      garmentClass === 'sleeveless-top' ? 'sleeveless' :
      /long[ -]?sleeve|longsleeve/.test(garmentText) || /outerwear|layer/.test(garmentClass) ? 'long' :
      /short[ -]?sleeve|shortsleeve|tee\b|t-shirt|t shirt|polo\b/.test(garmentText) ? 'short' :
      'short';

    root.classList.toggle('is-bottom-vto', mode === 'bottom');
    root.classList.toggle('is-bottom-pants', mode === 'bottom' && bottomType === 'pants');
    root.classList.toggle('is-bottom-shorts', mode === 'bottom' && bottomType === 'shorts');
    root.classList.toggle('is-bottom-skirt', mode === 'bottom' && bottomType === 'skirt');
    if (mode === 'bottom') {
      status.textContent =
        bottomType === 'skirt'
          ? 'Center your waist, hips, and lower body in the guide.'
          : bottomType === 'shorts'
            ? 'Center your waist, hips, and thighs in the guide.'
            : 'Center your waist, hips, and legs in the guide.';
    } else {
      status.textContent = 'Center your upper body in the guide.';
    }

    let stream = null;
    let facingMode = 'user';
    let mirrored = true;
    let bodyLockEnabled = true;
    let poseLandmarker = null;
    let poseLoading = null;
    let trackingFrame = null;
    let lastVideoTime = -1;
    let dragging = false;
    let dragStart = null;
    let dragBase = null;
    let smoothX = 50;
    let smoothY = 45;
    let smoothWidth = 72;
    let smoothAngle = 0;
    let smoothStretch = 1;
    let lastStableAt = 0;
    let stableFrames = 0;
    let hasStableLock = false;
    let lastTargetX = 50;
    let lastTargetY = 45;
    let lastTargetWidth = 72;
    let lastTargetAngle = 0;
    let lastTargetStretch = 1;
    let smoothAutoScale = 1;
    let lastAutoScale = 1;
    let smoothTeeMesh = null;
    const frameHistory = [];
    const filteredBodyPoints = new Map();
    const HISTORY_SIZE = 3;
    const median = (values) => {
      const sorted = values.slice().sort((a, b) => a - b);
      const middle = Math.floor(sorted.length / 2);
      return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
    };
    const normalizedBodyAngle = (degrees) => {
      let angle = degrees;
      while (angle > 90) angle -= 180;
      while (angle < -90) angle += 180;
      return clamp(angle, -14, 14);
    };

    const filteredBodyPoint = (index, landmark, metrics) => {
      const raw = pointOnStage(landmark, metrics);
      const previous = filteredBodyPoints.get(index);

      if (!previous) {
        filteredBodyPoints.set(index, raw);
        return raw;
      }

      const movement = Math.hypot(raw.x - previous.x, raw.y - previous.y);
      const reference = Math.max(1, Math.min(metrics.sw, metrics.sh));
      const movementRatio = movement / reference;
      const alpha =
        movementRatio > 0.055 ? 0.90 :
        movementRatio > 0.028 ? 0.76 :
        movementRatio > 0.012 ? 0.52 :
        movementRatio > 0.004 ? 0.32 :
        0.16;

      const filtered = {
        x: lerp(previous.x, raw.x, alpha),
        y: lerp(previous.y, raw.y, alpha),
        z: lerp(previous.z || 0, raw.z || 0, alpha)
      };

      filteredBodyPoints.set(index, filtered);
      return filtered;
    };

    const syncBottomImages = () => {
      const src = garment.currentSrc || garment.src;
      [bottomWaistImg, bottomLeftImg, bottomRightImg, bottomSkirtImg].forEach((image) => {
        if (image && image.src !== src) image.src = src;
      });
    };

    const setBottomRigVisible = (visible) => {
      if (!bottomRig) return;
      bottomRig.hidden = !visible;
      garment.style.display = visible ? 'none' : '';
    };

    const hideBottomParts = () => {
      if (bottomWaist) bottomWaist.hidden = true;
      if (bottomLeftWrap) bottomLeftWrap.hidden = true;
      if (bottomRightWrap) bottomRightWrap.hidden = true;
      if (bottomSkirt) bottomSkirt.hidden = true;
    };

    const placeBottomPart = (element, centerX, topY, widthPx, heightPx, angle, origin = '50% 0%') => {
      if (!element) return;
      element.style.left = `${centerX}px`;
      element.style.top = `${topY}px`;
      element.style.width = `${Math.max(1, widthPx)}px`;
      element.style.height = `${Math.max(1, heightPx)}px`;
      element.style.transformOrigin = origin;
      element.style.transform = `translateX(-50%) rotate(${angle.toFixed(2)}deg)`;
    };

    const verticalLegAngle = (a, b) =>
      clamp(Math.atan2(b.x - a.x, b.y - a.y) * 180 / Math.PI, -22, 22);

    const horizontalHipAngle = (a, b) => {
      let angle = Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI;
      while (angle > 90) angle -= 180;
      while (angle < -90) angle += 180;
      return clamp(angle, -10, 10);
    };

    const clearGarmentMesh = () => {
      if (!garmentMesh) return;
      const ctx = garmentMesh.getContext('2d');
      ctx.clearRect(0, 0, garmentMesh.width, garmentMesh.height);
      garmentMesh.style.display = 'none';
      smoothTeeMesh = null;
      if (mode !== 'bottom') garment.style.display = '';
    };

    const signedTriangleArea = (p0, p1, p2) =>
      (p1.x - p0.x) * (p2.y - p0.y) -
      (p1.y - p0.y) * (p2.x - p0.x);

    const drawTexturedTriangle = (ctx, image, s0, s1, s2, d0, d1, d2, dpr = 1) => {
      const sourceArea = signedTriangleArea(s0, s1, s2);
      const destinationArea = signedTriangleArea(d0, d1, d2);
      if (
        Math.abs(sourceArea) < 0.0001 ||
        Math.abs(destinationArea) < 0.5 ||
        sourceArea * destinationArea <= 0
      ) {
        return false;
      }

      const denominator =
        s0.x * (s1.y - s2.y) +
        s1.x * (s2.y - s0.y) +
        s2.x * (s0.y - s1.y);
      if (Math.abs(denominator) < 0.0001) return false;

      const a = (
        d0.x * (s1.y - s2.y) +
        d1.x * (s2.y - s0.y) +
        d2.x * (s0.y - s1.y)
      ) / denominator;
      const c = (
        d0.x * (s2.x - s1.x) +
        d1.x * (s0.x - s2.x) +
        d2.x * (s1.x - s0.x)
      ) / denominator;
      const e = (
        d0.x * (s1.x * s2.y - s2.x * s1.y) +
        d1.x * (s2.x * s0.y - s0.x * s2.y) +
        d2.x * (s0.x * s1.y - s1.x * s0.y)
      ) / denominator;
      const b = (
        d0.y * (s1.y - s2.y) +
        d1.y * (s2.y - s0.y) +
        d2.y * (s0.y - s1.y)
      ) / denominator;
      const d = (
        d0.y * (s2.x - s1.x) +
        d1.y * (s0.x - s2.x) +
        d2.y * (s1.x - s0.x)
      ) / denominator;
      const f = (
        d0.y * (s1.x * s2.y - s2.x * s1.y) +
        d1.y * (s2.x * s0.y - s0.x * s2.y) +
        d2.y * (s0.x * s1.y - s1.x * s0.y)
      ) / denominator;

      if (![a, b, c, d, e, f].every(Number.isFinite)) return false;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(d0.x, d0.y);
      ctx.lineTo(d1.x, d1.y);
      ctx.lineTo(d2.x, d2.y);
      ctx.closePath();
      ctx.clip();
      ctx.setTransform(
        a * dpr,
        b * dpr,
        c * dpr,
        d * dpr,
        e * dpr,
        f * dpr
      );
      ctx.drawImage(image, 0, 0);
      ctx.restore();
      return true;
    };

    const drawTexturedQuad = (ctx, image, source, destination, dpr = 1) => {
      const first = drawTexturedTriangle(
        ctx,
        image,
        source[0],
        source[1],
        source[2],
        destination[0],
        destination[1],
        destination[2],
        dpr
      );
      const second = drawTexturedTriangle(
        ctx,
        image,
        source[0],
        source[2],
        source[3],
        destination[0],
        destination[2],
        destination[3],
        dpr
      );
      return first && second;
    };

    const renderTeeMesh = ({
      leftShoulder,
      rightShoulder,
      leftElbow,
      rightElbow,
      leftHip,
      rightHip,
      shoulderSpanPx,
      hipSpanPx,
      userScale,
      yawSignal,
      neckCenter
    }) => {
      if (
        !garmentMesh ||
        !garmentAlphaBounds ||
        !garment.naturalWidth ||
        !garment.naturalHeight ||
        !/tee\\b|t-shirt|t shirt|polo\\b/.test(garmentText)
      ) {
        clearGarmentMesh();
        return false;
      }

      const metrics = coverMetrics();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const pixelWidth = Math.max(1, Math.round(metrics.sw * dpr));
      const pixelHeight = Math.max(1, Math.round(metrics.sh * dpr));
      if (garmentMesh.width !== pixelWidth || garmentMesh.height !== pixelHeight) {
        garmentMesh.width = pixelWidth;
        garmentMesh.height = pixelHeight;
      }

      const ctx = garmentMesh.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, metrics.sw, metrics.sh);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';

      const bounds = {
        left: garmentAlphaBounds.left * garment.naturalWidth,
        top: garmentAlphaBounds.top * garment.naturalHeight,
        width: garmentAlphaBounds.width * garment.naturalWidth,
        height: garmentAlphaBounds.height * garment.naturalHeight
      };
      const sx = (ratio) => bounds.left + bounds.width * ratio;
      const sy = (ratio) => bounds.top + bounds.height * ratio;

      const shoulderCenter = {
        x: (leftShoulder.x + rightShoulder.x) / 2,
        y: (leftShoulder.y + rightShoulder.y) / 2
      };
      const hipCenter = {
        x: (leftHip.x + rightHip.x) / 2,
        y: (leftHip.y + rightHip.y) / 2
      };
      const torsoLength = Math.max(1, Math.hypot(
        hipCenter.x - shoulderCenter.x,
        hipCenter.y - shoulderCenter.y
      ));
      const garmentScale = Number(scaleInput.value) / 85;
      const widthScale = Number(widthInput.value) / 100;
      const fitScale = garmentScale * userScale * smoothAutoScale;
      const sourceAspect = bounds.height / Math.max(1, bounds.width);
      const xOffset = Number(xInput.value) * metrics.sw / 100;
      const yOffset = Number(yInput.value) * metrics.sh / 100;

      const silhouetteWidth =
        shoulderSpanPx *
        (/oversized|boxy/.test(garmentText) ? 1.54 : /slim|fitted|baby tee/.test(garmentText) ? 1.30 : 1.46) *
        fitScale *
        widthScale;
      const sourceLength = silhouetteWidth * sourceAspect;
      const bodyLength =
        torsoLength *
        (/crop|cropped|baby tee/.test(garmentText) ? 0.84 : /longline/.test(garmentText) ? 1.20 : 1.02) *
        garmentScale *
        userScale *
        smoothAutoScale;
      const garmentLength = clamp(
        sourceLength * 0.82 + bodyLength * 0.18,
        torsoLength * 0.74,
        torsoLength * (/longline/.test(garmentText) ? 1.20 : 1.03)
      );

      const collarSourceRatio = 0.075;
      const collarTargetY =
        (neckCenter?.y ?? (shoulderCenter.y - shoulderSpanPx * 0.10)) +
        shoulderSpanPx * 0.018 +
        yOffset;
      const topY = collarTargetY - garmentLength * collarSourceRatio;
      const centerX =
        lerp(
          shoulderCenter.x,
          neckCenter?.x ?? shoulderCenter.x,
          0.28
        ) +
        yawSignal * shoulderSpanPx * 0.035 +
        xOffset;

      const meshColumns = 11;
      const meshRows = 13;
      const columnFractions = Array.from(
        { length: meshColumns },
        (_, index) => index / (meshColumns - 1)
      );
      const rowFractions = Array.from(
        { length: meshRows },
        (_, index) => index / (meshRows - 1)
      );

      const sleeveReach =
        /cap sleeve/.test(garmentText) ? 0.34 :
        /oversized|drop shoulder/.test(garmentText) ? 0.60 :
        0.50;
      const leftSleeveAnchor = {
        x: lerp(leftShoulder.x, leftElbow.x, sleeveReach),
        y: lerp(leftShoulder.y, leftElbow.y, sleeveReach)
      };
      const rightSleeveAnchor = {
        x: lerp(rightShoulder.x, rightElbow.x, sleeveReach),
        y: lerp(rightShoulder.y, rightElbow.y, sleeveReach)
      };

      const shoulderSlope = clamp(
        (rightShoulder.y - leftShoulder.y) / Math.max(1, shoulderSpanPx),
        -0.22,
        0.22
      );
      const hipSlope = clamp(
        (rightHip.y - leftHip.y) / Math.max(1, hipSpanPx),
        -0.18,
        0.18
      );

      const rawDestinationRows = rowFractions.map((ratio) => {
        const torsoProgress = clamp((ratio - 0.10) / 0.90, 0, 1);
        const bodyCenterX = lerp(shoulderCenter.x, hipCenter.x, torsoProgress);
        const rowCenterX =
          lerp(centerX, bodyCenterX + xOffset, torsoProgress * 0.54) +
          yawSignal * shoulderSpanPx * (0.036 - ratio * 0.016);

        const silhouetteTaper =
          ratio < 0.18
            ? lerp(1.00, 0.95, ratio / 0.18)
            : ratio < 0.55
              ? lerp(0.95, 0.83, (ratio - 0.18) / 0.37)
              : lerp(0.83, 0.87, (ratio - 0.55) / 0.45);
        const bodyTaper =
          ratio < 0.45
            ? lerp(1.00, 0.91, ratio / 0.45)
            : lerp(0.91, clamp(hipSpanPx / Math.max(1, shoulderSpanPx), 0.81, 1.03), (ratio - 0.45) / 0.55);
        const rowWidth = silhouetteWidth * (silhouetteTaper * 0.74 + bodyTaper * 0.26);
        const half = rowWidth / 2;
        const leftPerspective = clamp(1 + yawSignal * 0.27, 0.93, 1.07);
        const rightPerspective = clamp(1 - yawSignal * 0.27, 0.93, 1.07);
        const y = topY + garmentLength * ratio;
        const sleeveInfluence = clamp((0.34 - ratio) / 0.34, 0, 1);
        const shoulderSlopeInfluence = clamp((0.34 - ratio) / 0.34, 0, 1);
        const hemSlopeInfluence = clamp((ratio - 0.72) / 0.28, 0, 1);

        return columnFractions.map((fraction) => {
          const normalized = (fraction - 0.5) * 2;
          const absNormalized = Math.abs(normalized);
          const perspective = normalized < 0 ? leftPerspective : rightPerspective;
          const curve = normalized * (1 - 0.020 * (1 - normalized * normalized));
          let x = rowCenterX + curve * half * perspective;
          let pointY =
            y +
            normalized * shoulderSpanPx * shoulderSlope * 0.36 * shoulderSlopeInfluence +
            normalized * hipSpanPx * hipSlope * 0.10 * hemSlopeInfluence +
            absNormalized * shoulderSpanPx * 0.012 * (1 - ratio);

          if (sleeveInfluence > 0 && absNormalized > 0.56) {
            const edgeInfluence = clamp((absNormalized - 0.56) / 0.44, 0, 1) * sleeveInfluence;
            const target = normalized < 0 ? leftSleeveAnchor : rightSleeveAnchor;
            x = lerp(x, target.x + xOffset, edgeInfluence * 0.58);
            pointY = lerp(pointY, target.y + yOffset, edgeInfluence * 0.50);
          }

          const graphicProtection =
            ratio >= 0.22 && ratio <= 0.68
              ? clamp(1 - absNormalized / 0.46, 0, 1)
              : 0;
          if (graphicProtection > 0) {
            const stableHalf = silhouetteWidth * (
              ratio < 0.42 ? 0.425 : ratio < 0.60 ? 0.392 : 0.372
            );
            const stableX =
              rowCenterX +
              normalized * stableHalf *
              (normalized < 0 ? leftPerspective : rightPerspective);
            x = lerp(x, stableX, graphicProtection * 0.66);
            pointY = lerp(pointY, y, graphicProtection * 0.80);
          }

          const hemFreedom = clamp((ratio - 0.78) / 0.22, 0, 1);
          if (hemFreedom > 0) {
            x += yawSignal * normalized * shoulderSpanPx * 0.025 * hemFreedom;
            pointY += absNormalized * shoulderSpanPx * 0.010 * hemFreedom;
          }

          return { x, y: pointY };
        });
      });

      if (
        !smoothTeeMesh ||
        smoothTeeMesh.length !== rawDestinationRows.length ||
        smoothTeeMesh[0]?.length !== rawDestinationRows[0]?.length
      ) {
        smoothTeeMesh = rawDestinationRows.map((row) => row.map((point) => ({ ...point })));
      } else {
        rawDestinationRows.forEach((row, rowIndex) => {
          row.forEach((point, colIndex) => {
            const previous = smoothTeeMesh[rowIndex][colIndex];
            const fraction = columnFractions[colIndex];
            const normalized = Math.abs((fraction - 0.5) * 2);
            const ratio = rowFractions[rowIndex];
            const graphicZone = ratio >= 0.22 && ratio <= 0.68 && normalized < 0.52;
            const sleeveZone = ratio < 0.34 && normalized > 0.56;
            const hemZone = ratio > 0.78;
            const delta = Math.hypot(point.x - previous.x, point.y - previous.y);
            const baseEase =
              sleeveZone ? 0.46 :
              hemZone ? 0.26 :
              graphicZone ? 0.20 :
              0.28;
            const ease = delta > shoulderSpanPx * 0.12
              ? Math.max(baseEase, 0.52)
              : delta > shoulderSpanPx * 0.05
                ? Math.max(baseEase, 0.38)
                : baseEase;
            previous.x = lerp(previous.x, point.x, ease);
            previous.y = lerp(previous.y, point.y, ease);
          });
        });
      }

      const destinationRows = smoothTeeMesh;

      const sourceRows = rowFractions.map((ratio) =>
        columnFractions.map((fraction) => ({
          x: sx(fraction),
          y: sy(ratio)
        }))
      );

      let validMeshPatches = 0;
      let attemptedMeshPatches = 0;
      for (let row = 0; row < meshRows - 1; row += 1) {
        for (let col = 0; col < meshColumns - 1; col += 1) {
          attemptedMeshPatches += 1;
          if (
            drawTexturedQuad(
              ctx,
              garment,
              [
                sourceRows[row][col],
                sourceRows[row][col + 1],
                sourceRows[row + 1][col + 1],
                sourceRows[row + 1][col]
              ],
              [
                destinationRows[row][col],
                destinationRows[row][col + 1],
                destinationRows[row + 1][col + 1],
                destinationRows[row + 1][col]
              ],
              dpr
            )
          ) {
            validMeshPatches += 1;
          }
        }
      }

      const sampleStep = Math.max(4, Math.round(dpr * 5));
      const meshPixels = ctx.getImageData(0, 0, garmentMesh.width, garmentMesh.height).data;
      let visibleSamples = 0;
      let totalSamples = 0;
      for (let y = 0; y < garmentMesh.height; y += sampleStep) {
        for (let x = 0; x < garmentMesh.width; x += sampleStep) {
          totalSamples += 1;
          if (meshPixels[(y * garmentMesh.width + x) * 4 + 3] > 28) visibleSamples += 1;
        }
      }

      const visibleRatio = visibleSamples / Math.max(1, totalSamples);
      const expectedArea = Math.max(
        0.018,
        (silhouetteWidth * garmentLength * 0.42) / Math.max(1, metrics.sw * metrics.sh)
      );
      const meshLooksUsable =
        validMeshPatches >= attemptedMeshPatches - 2 &&
        visibleRatio >= expectedArea * 0.34;

      if (!meshLooksUsable) {
        ctx.clearRect(0, 0, metrics.sw, metrics.sh);
        garmentMesh.style.display = 'none';
        garment.style.display = '';
        return false;
      }

      garmentMesh.style.display = 'block';
      garment.style.display = 'none';
      return true;
    };

    const renderBottomRig = ({
      leftHip,
      rightHip,
      leftKnee,
      rightKnee,
      leftAnkle,
      rightAnkle,
      hipSpanPx,
      userScale
    }) => {
      setBottomRigVisible(true);
      hideBottomParts();
      syncBottomImages();

      const hipCenter = {
        x: (leftHip.x + rightHip.x) / 2,
        y: (leftHip.y + rightHip.y) / 2
      };
      const kneeCenter = {
        x: (leftKnee.x + rightKnee.x) / 2,
        y: (leftKnee.y + rightKnee.y) / 2
      };
      const hipAngle = horizontalHipAngle(leftHip, rightHip);
      const widthScale = Number(widthInput.value) / 100;
      const waistWidth = hipSpanPx * (bottomType === 'skirt' ? 1.55 : 1.34) * userScale * smoothAutoScale * widthScale;
      const riseHeight = hipSpanPx * (bottomType === 'shorts' ? 0.55 : 0.62);

      if (bottomType === 'skirt') {
        bottomWaist.hidden = false;
        bottomSkirt.hidden = false;
        const ankleCenter = {
          x: (leftAnkle.x + rightAnkle.x) / 2,
          y: (leftAnkle.y + rightAnkle.y) / 2
        };
        const hipToKnee = Math.hypot(kneeCenter.x - hipCenter.x, kneeCenter.y - hipCenter.y);
        const kneeToAnkle = Math.hypot(ankleCenter.x - kneeCenter.x, ankleCenter.y - kneeCenter.y);
        const skirtLength =
          /maxi\b/.test(garmentText) ? hipToKnee + kneeToAnkle * 0.92 :
          /midi\b/.test(garmentText) ? hipToKnee + kneeToAnkle * 0.52 :
          /mini\b|micro/.test(garmentText) ? hipToKnee * 0.58 :
          hipToKnee * 0.96;
        const skirtShape =
          /pencil|bodycon|fitted/.test(garmentText) ? 1.24 :
          /pleat|circle|a-line|aline|skater/.test(garmentText) ? 1.78 :
          1.52;
        const skirtWidth = hipSpanPx * skirtShape * userScale * smoothAutoScale * widthScale;
        const skirtWaistWidth = hipSpanPx * 1.30 * userScale * smoothAutoScale * widthScale;
        placeBottomPart(bottomWaist, hipCenter.x, hipCenter.y - riseHeight * 0.44, skirtWaistWidth, riseHeight * 0.92, hipAngle, '50% 50%');
        placeBottomPart(bottomSkirt, hipCenter.x, hipCenter.y - riseHeight * 0.04, skirtWidth, Math.max(hipSpanPx * 0.72, skirtLength), hipAngle);
        return;
      }

      const leftTarget = bottomType === 'shorts' ? leftKnee : leftAnkle;
      const rightTarget = bottomType === 'shorts' ? rightKnee : rightAnkle;
      const leftLength = Math.hypot(leftTarget.x - leftHip.x, leftTarget.y - leftHip.y);
      const rightLength = Math.hypot(rightTarget.x - rightHip.x, rightTarget.y - rightHip.y);
      const leftAngle = verticalLegAngle(leftHip, leftTarget);
      const rightAngle = verticalLegAngle(rightHip, rightTarget);
      const ankleSeparation = Math.abs(rightTarget.x - leftTarget.x) / Math.max(1, hipSpanPx);
      const legAngleSeparation = Math.abs(leftAngle - rightAngle);
      const needsArticulation =
        bottomType === 'shorts' ||
        ankleSeparation > 1.22 ||
        legAngleSeparation > 13;

      if (bottomType === 'pants' && !needsArticulation) {
        setBottomRigVisible(false);
        garment.style.display = '';
        const averageLegLength = (leftLength + rightLength) / 2;
        const desiredVisibleHeight = averageLegLength + riseHeight * 1.22;
        const kneeSpan = Math.hypot(
          rightKnee.x - leftKnee.x,
          rightKnee.y - leftKnee.y
        );
        const ankleSpan = Math.hypot(
          rightAnkle.x - leftAnkle.x,
          rightAnkle.y - leftAnkle.y
        );
        const lowerBodyWidthSignal = clamp(
          (hipSpanPx * 0.58 + kneeSpan * 0.30 + ankleSpan * 0.12) / Math.max(1, hipSpanPx),
          0.76,
          1.02
        );
        const pantsWidthProfile =
          /wide[- ]?leg|palazzo/.test(garmentText) ? 1.14 :
          /flare|bootcut/.test(garmentText) ? 1.06 :
          /skinny|slim|legging/.test(garmentText) ? 0.86 :
          0.96;
        const desiredVisibleWidth = waistWidth * pantsWidthProfile * lowerBodyWidthSignal;
        const alphaWidth = garmentAlphaBounds ? Math.max(0.18, garmentAlphaBounds.width) : 1;
        const alphaHeight = garmentAlphaBounds ? Math.max(0.18, garmentAlphaBounds.height) : 1;
        const renderedBoxWidth = desiredVisibleWidth / alphaWidth;
        const renderedBoxHeight = desiredVisibleHeight / alphaHeight;
        const visibleTopOffset = garmentAlphaBounds ? garmentAlphaBounds.top * renderedBoxHeight : 0;
        const visibleLeftOffset = garmentAlphaBounds
          ? (garmentAlphaBounds.left + garmentAlphaBounds.width / 2 - 0.5) * renderedBoxWidth
          : 0;
        garment.style.left = `${hipCenter.x - visibleLeftOffset}px`;
        const waistbandDrop = clamp(riseHeight * 0.12, 3, 14);
        garment.style.top = `${hipCenter.y - riseHeight * 0.54 + waistbandDrop - visibleTopOffset}px`;
        garment.style.width = `${Math.max(1, renderedBoxWidth)}px`;
        garment.style.height = `${Math.max(1, renderedBoxHeight)}px`;
        garment.style.objectFit = 'fill';
        garment.style.borderRadius = `${Math.max(0, hipSpanPx * 0.035)}px ${Math.max(0, hipSpanPx * 0.035)}px 0 0`;
        garment.style.transformOrigin = '50% 0%';
        const leftHipDepth = Number(landmarks[23]?.z || 0);
        const rightHipDepth = Number(landmarks[24]?.z || 0);
        const hipYaw = clamp((rightHipDepth - leftHipDepth) * 2.1, -0.20, 0.20);
        const waistPerspective = clamp(
          (1 - Math.abs(hipAngle) * 0.006) * (1 - Math.abs(hipYaw) * 0.46),
          0.86,
          1
        );
        const hipYawShift = hipYaw * hipSpanPx * 0.22;
        garment.style.left = `${hipCenter.x - visibleLeftOffset + hipYawShift}px`;
        garment.style.transform = `translateX(-50%) rotate(${hipAngle.toFixed(2)}deg) scaleX(${waistPerspective.toFixed(3)})`;
        return;
      }

      setBottomRigVisible(true);
      bottomWaist.hidden = false;
      bottomLeftWrap.hidden = false;
      bottomRightWrap.hidden = false;

      const pantsLegFactor =
        /wide[- ]?leg|palazzo|flare|bootcut/.test(garmentText) ? 0.82 :
        /skinny|slim|legging/.test(garmentText) ? 0.58 :
        0.70;
      const shortsLengthFactor =
        /bermuda|long short/.test(garmentText) ? 0.92 :
        /micro|hot pant/.test(garmentText) ? 0.42 :
        0.68;
      const legWidth = hipSpanPx * (bottomType === 'shorts' ? 0.66 : pantsLegFactor) * userScale * smoothAutoScale * widthScale;
      const legTop = hipSpanPx * (bottomType === 'shorts' ? 0.02 : 0.08);
      const upperBridgeWidth = waistWidth * (bottomType === 'shorts' ? 1.02 : 1.12);
      const upperBridgeHeight = riseHeight * (bottomType === 'shorts' ? 1.04 : 1.48);

      placeBottomPart(
        bottomWaist,
        hipCenter.x,
        hipCenter.y - riseHeight * 0.58,
        upperBridgeWidth,
        upperBridgeHeight,
        hipAngle,
        '50% 50%'
      );
      placeBottomPart(
        bottomLeftWrap,
        leftHip.x + hipSpanPx * 0.02,
        leftHip.y - legTop,
        legWidth,
        leftLength * (bottomType === 'shorts' ? shortsLengthFactor : 1.04),
        leftAngle
      );
      placeBottomPart(
        bottomRightWrap,
        rightHip.x - hipSpanPx * 0.02,
        rightHip.y - legTop,
        legWidth,
        rightLength * (bottomType === 'shorts' ? shortsLengthFactor : 1.04),
        rightAngle
      );
    };

    garment.addEventListener('load', () => {
      syncBottomImages();
      requestAnimationFrame(updateBottomGuideToGarment);
    });
    syncBottomImages();

    const updateVideoMirror = () => {
      video.style.transform = mirrored ? 'scaleX(-1)' : 'scaleX(1)';
    };

    let garmentAlphaBounds = null;
    let garmentGeometry = null;

    const updateBottomGuideToGarment = () => {
      if (mode !== 'bottom' || !garmentAlphaBounds || !garment.naturalWidth || !garment.naturalHeight) return;

      const stageRect = stage.getBoundingClientRect();
      const garmentRect = garment.getBoundingClientRect();
      if (!stageRect.width || !stageRect.height || !garmentRect.width || !garmentRect.height) return;

      const visibleLeft = garmentRect.left + garmentRect.width * garmentAlphaBounds.left;
      const visibleTop = garmentRect.top + garmentRect.height * garmentAlphaBounds.top;
      const visibleWidth = garmentRect.width * garmentAlphaBounds.width;
      const visibleHeight = garmentRect.height * garmentAlphaBounds.height;

      const padX = Math.max(6, visibleWidth * 0.035);
      const padY = Math.max(6, visibleHeight * 0.022);

      const leftPct = ((visibleLeft - stageRect.left - padX) / stageRect.width) * 100;
      const topPct = ((visibleTop - stageRect.top - padY) / stageRect.height) * 100;
      const widthPct = ((visibleWidth + padX * 2) / stageRect.width) * 100;
      const heightPct = ((visibleHeight + padY * 2) / stageRect.height) * 100;

      root.style.setProperty('--vto-bottom-guide-left', `${clamp(leftPct, 2, 94)}%`);
      root.style.setProperty('--vto-bottom-guide-top', `${clamp(topPct, 2, 94)}%`);
      root.style.setProperty('--vto-bottom-guide-width', `${clamp(widthPct, 12, 92)}%`);
      root.style.setProperty('--vto-bottom-guide-height', `${clamp(heightPct, 18, 92)}%`);
    };

    const applyManualPosition = () => {
      clearGarmentMesh();
      const scale = Number(scaleInput.value) / 100;
      const widthScale = Number(widthInput.value) / 100;
      garment.style.width = `${72 * scale * widthScale}%`;
      garment.style.left = `${50 + Number(xInput.value)}%`;
      garment.style.top = `${45 + Number(yInput.value)}%`;
      garment.style.transform = 'translate(-50%, -50%)';
      requestAnimationFrame(updateBottomGuideToGarment);
    };

    const stopCamera = () => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        stream = null;
      }
      video.srcObject = null;
    };

    const clearOcclusion = () => {
      const ctx = occlusion.getContext('2d');
      ctx.clearRect(0, 0, occlusion.width, occlusion.height);
    };

    const stopTracking = () => {
      if (trackingFrame) cancelAnimationFrame(trackingFrame);
      trackingFrame = null;
      stableFrames = 0;
      hasStableLock = false;
      lastStableAt = 0;
      frameHistory.length = 0;
      filteredBodyPoints.clear();
      smoothAutoScale = 1;
      lastAutoScale = 1;
      smoothTeeMesh = null;
      stage.classList.remove('is-tracking');
      garment.classList.remove('is-tracking');
      setBottomRigVisible(false);
      hideBottomParts();
      clearGarmentMesh();
      clearOcclusion();
    };

    const makeGarmentBackgroundTransparent = async () => {
      if (!garment.complete || !garment.naturalWidth) {
        await new Promise((resolve) => {
          garment.addEventListener('load', resolve, { once: true });
        });
      }

      try {
        const canvas = document.createElement('canvas');
        const maxWidth = 900;
        const ratio = Math.min(1, maxWidth / garment.naturalWidth);
        canvas.width = Math.max(1, Math.round(garment.naturalWidth * ratio));
        canvas.height = Math.max(1, Math.round(garment.naturalHeight * ratio));

        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(garment, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const pixels = imageData.data;
        const width = canvas.width;
        const height = canvas.height;
        const total = width * height;

        const borderR = [];
        const borderG = [];
        const borderB = [];
        const sampleStep = Math.max(1, Math.floor(Math.min(width, height) / 180));

        const samplePixel = (x, y) => {
          const offset = (y * width + x) * 4;
          borderR.push(pixels[offset]);
          borderG.push(pixels[offset + 1]);
          borderB.push(pixels[offset + 2]);
        };

        for (let x = 0; x < width; x += sampleStep) {
          samplePixel(x, 0);
          samplePixel(x, height - 1);
        }
        for (let y = 0; y < height; y += sampleStep) {
          samplePixel(0, y);
          samplePixel(width - 1, y);
        }

        const bgR = median(borderR);
        const bgG = median(borderG);
        const bgB = median(borderB);
        const colorDistance = (r1, g1, b1, r2, g2, b2) =>
          Math.hypot(r1 - r2, g1 - g2, b1 - b2);
        const borderDistances = borderR.map((r, index) =>
          colorDistance(r, borderG[index], borderB[index], bgR, bgG, bgB)
        );
        const bgSpread = median(borderDistances);
        const lightGarmentHint =
          /white|off[- ]?white|cream|ivory|ecru|beige|pale|champagne|oatmeal|natural/.test(garmentText);
        const seedTolerance = lightGarmentHint
          ? clamp(12 + bgSpread * 0.55, 14, 24)
          : clamp(18 + bgSpread * 0.9, 20, 36);
        const floodTolerance = lightGarmentHint
          ? clamp(22 + bgSpread * 0.85, 26, 40)
          : clamp(30 + bgSpread * 1.4, 34, 58);
        const localTolerance = lightGarmentHint
          ? clamp(9 + bgSpread * 0.4, 10, 16)
          : clamp(12 + bgSpread * 0.6, 14, 22);

        const localContrast = (pixelIndex) => {
          const x = pixelIndex % width;
          const y = Math.floor(pixelIndex / width);
          const offset = pixelIndex * 4;
          let strongest = 0;
          const neighbors = [];
          if (x > 0) neighbors.push(pixelIndex - 1);
          if (x < width - 1) neighbors.push(pixelIndex + 1);
          if (y > 0) neighbors.push(pixelIndex - width);
          if (y < height - 1) neighbors.push(pixelIndex + width);
          neighbors.forEach((neighborIndex) => {
            const neighborOffset = neighborIndex * 4;
            strongest = Math.max(
              strongest,
              colorDistance(
                pixels[offset],
                pixels[offset + 1],
                pixels[offset + 2],
                pixels[neighborOffset],
                pixels[neighborOffset + 1],
                pixels[neighborOffset + 2]
              )
            );
          });
          return strongest;
        };

        const backgroundMask = new Uint8Array(total);
        const queue = new Int32Array(total);
        let queueHead = 0;
        let queueTail = 0;

        const directBackgroundMatch = (pixelIndex, tolerance = seedTolerance) => {
          const offset = pixelIndex * 4;
          if (pixels[offset + 3] === 0) return true;
          return colorDistance(
            pixels[offset],
            pixels[offset + 1],
            pixels[offset + 2],
            bgR,
            bgG,
            bgB
          ) <= tolerance;
        };

        const adaptiveBackgroundMatch = (currentIndex, nextIndex) => {
          const currentOffset = currentIndex * 4;
          const nextOffset = nextIndex * 4;
          const nextToBackground = colorDistance(
            pixels[nextOffset],
            pixels[nextOffset + 1],
            pixels[nextOffset + 2],
            bgR,
            bgG,
            bgB
          );
          const localDistance = colorDistance(
            pixels[currentOffset],
            pixels[currentOffset + 1],
            pixels[currentOffset + 2],
            pixels[nextOffset],
            pixels[nextOffset + 1],
            pixels[nextOffset + 2]
          );
          const edgeStrength = localContrast(nextIndex);

          return (
            nextToBackground <= floodTolerance &&
            localDistance <= localTolerance &&
            edgeStrength <= localTolerance * 1.35
          );
        };

        const addSeed = (pixelIndex) => {
          if (backgroundMask[pixelIndex] || !directBackgroundMatch(pixelIndex)) return;
          backgroundMask[pixelIndex] = 1;
          queue[queueTail++] = pixelIndex;
        };

        for (let x = 0; x < width; x += 1) {
          addSeed(x);
          addSeed((height - 1) * width + x);
        }
        for (let y = 0; y < height; y += 1) {
          addSeed(y * width);
          addSeed(y * width + width - 1);
        }

        const tryNeighbor = (currentIndex, nextIndex) => {
          if (
            nextIndex < 0 ||
            nextIndex >= total ||
            backgroundMask[nextIndex] ||
            !adaptiveBackgroundMatch(currentIndex, nextIndex)
          ) {
            return;
          }

          backgroundMask[nextIndex] = 1;
          queue[queueTail++] = nextIndex;
        };

        while (queueHead < queueTail) {
          const index = queue[queueHead++];
          const x = index % width;
          if (x > 0) tryNeighbor(index, index - 1);
          if (x < width - 1) tryNeighbor(index, index + 1);
          if (index >= width) tryNeighbor(index, index - width);
          if (index < total - width) tryNeighbor(index, index + width);
        }

        if (lightGarmentHint) {
          const strongThreshold = Math.max(34, floodTolerance * 1.12);
          const rowContours = new Array(height).fill(null);
          for (let y = 0; y < height; y += 1) {
            let left = width;
            let right = -1;
            for (let x = 0; x < width; x += 1) {
              const index = y * width + x;
              const offset = index * 4;
              if (pixels[offset + 3] === 0) continue;
              const distance = colorDistance(
                pixels[offset],
                pixels[offset + 1],
                pixels[offset + 2],
                bgR,
                bgG,
                bgB
              );
              const contrast = localContrast(index);
              if (distance >= strongThreshold || contrast >= localTolerance * 1.8) {
                if (x < left) left = x;
                if (x > right) right = x;
              }
            }
            if (right >= left && right - left >= width * 0.035) {
              rowContours[y] = { left, right };
            }
          }

          const contourPadding = Math.max(2, Math.round(width * 0.012));
          for (let y = 0; y < height; y += 1) {
            let contour = rowContours[y];
            if (!contour) {
              for (let radius = 1; radius <= 5 && !contour; radius += 1) {
                contour = rowContours[y - radius] || rowContours[y + radius] || null;
              }
            }
            if (!contour) continue;

            const protectedLeft = Math.max(0, contour.left - contourPadding);
            const protectedRight = Math.min(width - 1, contour.right + contourPadding);
            for (let x = protectedLeft; x <= protectedRight; x += 1) {
              const index = y * width + x;
              if (!backgroundMask[index]) continue;
              const offset = index * 4;
              const distance = colorDistance(
                pixels[offset],
                pixels[offset + 1],
                pixels[offset + 2],
                bgR,
                bgG,
                bgB
              );
              const contrast = localContrast(index);
              if (
                distance > seedTolerance * 0.72 ||
                contrast > localTolerance * 1.08
              ) {
                backgroundMask[index] = 0;
              }
            }
          }
        }

        for (let i = 0; i < total; i += 1) {
          if (backgroundMask[i]) pixels[i * 4 + 3] = 0;
        }

        const edgePixels = [];
        for (let i = 0; i < total; i += 1) {
          if (backgroundMask[i]) continue;
          const x = i % width;
          const y = Math.floor(i / width);
          let touchesBackground = false;

          for (let dy = -1; dy <= 1 && !touchesBackground; dy += 1) {
            for (let dx = -1; dx <= 1; dx += 1) {
              if (dx === 0 && dy === 0) continue;
              const nx = x + dx;
              const ny = y + dy;
              if (nx < 0 || nx >= width || ny < 0 || ny >= height) continue;
              if (backgroundMask[ny * width + nx]) {
                touchesBackground = true;
                break;
              }
            }
          }

          if (!touchesBackground) continue;

          const offset = i * 4;
          const bgDistance = colorDistance(
            pixels[offset],
            pixels[offset + 1],
            pixels[offset + 2],
            bgR,
            bgG,
            bgB
          );

          const edgeStrength = localContrast(i);
          if (
            bgDistance <= seedTolerance * 1.18 &&
            edgeStrength <= localTolerance * 1.45
          ) {
            edgePixels.push({ index: i, bgDistance });
          }
        }

        edgePixels.forEach(({ index, bgDistance }) => {
          const closeness = clamp(
            1 - bgDistance / Math.max(1, seedTolerance * 1.18),
            0,
            1
          );
          const minimumAlpha = lightGarmentHint ? 0.52 : 0.28;
          const retainedAlpha = clamp(
            minimumAlpha + (1 - closeness) * (0.90 - minimumAlpha),
            minimumAlpha,
            0.90
          );
          pixels[index * 4 + 3] = Math.round(pixels[index * 4 + 3] * retainedAlpha);
        });

        if (lightGarmentHint) {
          const haloThreshold = Math.max(seedTolerance * 1.35, 24);
          const haloMask = new Uint8Array(total);
          for (let i = 0; i < total; i += 1) {
            if (pixels[i * 4 + 3] <= 24) continue;
            const x = i % width;
            const y = Math.floor(i / width);
            const offset = i * 4;
            const distance = colorDistance(
              pixels[offset],
              pixels[offset + 1],
              pixels[offset + 2],
              bgR,
              bgG,
              bgB
            );
            if (
              distance <= haloThreshold &&
              localContrast(i) <= localTolerance * 1.12 &&
              (x < width * 0.16 || x > width * 0.84 || y < height * 0.08 || y > height * 0.92)
            ) {
              haloMask[i] = 1;
            }
          }

          for (let pass = 0; pass < 5; pass += 1) {
            const nextMask = haloMask.slice();
            for (let i = 0; i < total; i += 1) {
              if (haloMask[i] || pixels[i * 4 + 3] <= 24) continue;
              const x = i % width;
              const y = Math.floor(i / width);
              const offset = i * 4;
              const distance = colorDistance(
                pixels[offset],
                pixels[offset + 1],
                pixels[offset + 2],
                bgR,
                bgG,
                bgB
              );
              if (distance > haloThreshold || localContrast(i) > localTolerance * 1.10) continue;
              if (
                (x > 0 && haloMask[i - 1]) ||
                (x < width - 1 && haloMask[i + 1]) ||
                (y > 0 && haloMask[i - width]) ||
                (y < height - 1 && haloMask[i + width])
              ) {
                nextMask[i] = 1;
              }
            }
            haloMask.set(nextMask);
          }

          for (let i = 0; i < total; i += 1) {
            if (haloMask[i]) pixels[i * 4 + 3] = 0;
          }
        }

        let minX = width;
        let minY = height;
        let maxX = -1;
        let maxY = -1;

        for (let i = 0; i < total; i += 1) {
          if (pixels[i * 4 + 3] <= 24) continue;
          const x = i % width;
          const y = Math.floor(i / width);
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }

        if (maxX >= minX && maxY >= minY) {
          garmentAlphaBounds = {
            left: minX / width,
            top: minY / height,
            width: (maxX - minX + 1) / width,
            height: (maxY - minY + 1) / height
          };

          const rowExtent = (rowY) => {
            let left = width;
            let right = -1;
            for (let x = minX; x <= maxX; x += 1) {
              if (pixels[(rowY * width + x) * 4 + 3] <= 40) continue;
              if (x < left) left = x;
              if (x > right) right = x;
            }
            return right >= left ? { left, right, width: right - left + 1 } : null;
          };
          const geometryRows = [];
          for (let step = 0; step <= 20; step += 1) {
            const y = Math.round(minY + (maxY - minY) * (step / 20));
            const extent = rowExtent(y);
            if (extent) geometryRows.push({ y, ...extent });
          }
          const upperRows = geometryRows.filter((row) => row.y <= minY + (maxY - minY) * 0.34);
          const shoulderRow = upperRows.reduce(
            (best, row) => !best || row.width > best.width ? row : best,
            null
          );
          const waistRows = geometryRows.filter((row) => {
            const ratio = (row.y - minY) / Math.max(1, maxY - minY);
            return ratio >= 0.42 && ratio <= 0.68;
          });
          const waistRow = waistRows.reduce(
            (best, row) => !best || row.width < best.width ? row : best,
            null
          );
          garmentGeometry = {
            shoulderWidthRatio: shoulderRow ? shoulderRow.width / Math.max(1, maxX - minX + 1) : 1,
            shoulderYRatio: shoulderRow ? (shoulderRow.y - minY) / Math.max(1, maxY - minY) : 0.16,
            waistWidthRatio: waistRow ? waistRow.width / Math.max(1, maxX - minX + 1) : 0.82,
            aspect: (maxY - minY + 1) / Math.max(1, maxX - minX + 1),
            rows: geometryRows.map((row) => ({
              y: (row.y - minY) / Math.max(1, maxY - minY),
              left: (row.left - minX) / Math.max(1, maxX - minX + 1),
              right: (row.right - minX) / Math.max(1, maxX - minX + 1)
            }))
          };
        }

        ctx.putImageData(imageData, 0, 0);
        garment.src = canvas.toDataURL('image/png');
        requestAnimationFrame(() => requestAnimationFrame(updateBottomGuideToGarment));
      } catch (error) {
        garment.style.opacity = '.99';
      }
    };

    const loadPoseModel = async () => {
      if (poseLandmarker) return poseLandmarker;
      if (poseLoading) return poseLoading;

      poseLoading = (async () => {
        try {
          const vision = await import('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/+esm');
          const fileset = await vision.FilesetResolver.forVisionTasks(
            'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm'
          );
          poseLandmarker = await vision.PoseLandmarker.createFromOptions(fileset, {
            baseOptions: {
              modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/latest/pose_landmarker_lite.task'
            },
            runningMode: 'VIDEO',
            numPoses: 1,
            minPoseDetectionConfidence: 0.5,
            minPosePresenceConfidence: 0.5,
            minTrackingConfidence: 0.5
          });
          return poseLandmarker;
        } catch (error) {
          status.textContent = 'Body lock is unavailable on this browser. Manual try-on still works.';
          bodyLockEnabled = false;
          lockButton.textContent = 'Body lock: Off';
          return null;
        } finally {
          poseLoading = null;
        }
      })();

      return poseLoading;
    };

    const coverMetrics = () => {
      const stageRect = stage.getBoundingClientRect();
      const sw = stageRect.width;
      const sh = stageRect.height;
      const vw = video.videoWidth || sw;
      const vh = video.videoHeight || sh;
      const scale = Math.max(sw / vw, sh / vh);
      const dw = vw * scale;
      const dh = vh * scale;
      return { sw, sh, dw, dh, dx: (sw - dw) / 2, dy: (sh - dh) / 2 };
    };

    const pointOnStage = (landmark, metrics) => {
      let x = metrics.dx + landmark.x * metrics.dw;
      if (mirrored) x = metrics.sw - x;
      return { x, y: metrics.dy + landmark.y * metrics.dh, z: landmark.z || 0 };
    };

    const drawCameraIntoCurrentClip = (ctx, metrics) => {
      ctx.save();
      if (mirrored) {
        ctx.translate(metrics.sw, 0);
        ctx.scale(-1, 1);
      }
      ctx.drawImage(video, metrics.dx, metrics.dy, metrics.dw, metrics.dh);
      ctx.restore();
    };

    const addCircle = (ctx, p, radius) => {
      ctx.moveTo(p.x + radius, p.y);
      ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
    };

    const addThickSegment = (ctx, a, b, radius) => {
      const angle = Math.atan2(b.y - a.y, b.x - a.x);
      const nx = Math.sin(angle) * radius;
      const ny = -Math.cos(angle) * radius;
      ctx.moveTo(a.x + nx, a.y + ny);
      ctx.lineTo(b.x + nx, b.y + ny);
      ctx.arc(b.x, b.y, radius, angle - Math.PI / 2, angle + Math.PI / 2);
      ctx.lineTo(a.x - nx, a.y - ny);
      ctx.arc(a.x, a.y, radius, angle + Math.PI / 2, angle - Math.PI / 2);
      ctx.closePath();
    };

    const renderBottomOcclusion = (landmarks, hipSpanPx) => {
      const metrics = coverMetrics();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1, Math.round(metrics.sw * dpr));
      const height = Math.max(1, Math.round(metrics.sh * dpr));
      if (occlusion.width !== width || occlusion.height !== height) {
        occlusion.width = width;
        occlusion.height = height;
      }
      const ctx = occlusion.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, metrics.sw, metrics.sh);
      const p = (index) => pointOnStage(landmarks[index], metrics);
      const leftElbow = p(13);
      const rightElbow = p(14);
      const leftWrist = p(15);
      const rightWrist = p(16);
      const leftIndex = p(19);
      const rightIndex = p(20);
      const handRadius = clamp(hipSpanPx * 0.16, 10, 30);
      const forearmRadius = clamp(hipSpanPx * 0.105, 8, 22);
      ctx.save();
      ctx.beginPath();
      addCircle(ctx, leftWrist, handRadius);
      addCircle(ctx, rightWrist, handRadius);
      addCircle(ctx, leftIndex, handRadius * 0.62);
      addCircle(ctx, rightIndex, handRadius * 0.62);
      addThickSegment(ctx, leftElbow, leftWrist, forearmRadius);
      addThickSegment(ctx, rightElbow, rightWrist, forearmRadius);
      ctx.clip();
      drawCameraIntoCurrentClip(ctx, metrics);
      ctx.restore();
    };

    const renderOcclusion = (landmarks, shoulderSpanPx, torsoBounds) => {
      const metrics = coverMetrics();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const width = Math.max(1, Math.round(metrics.sw * dpr));
      const height = Math.max(1, Math.round(metrics.sh * dpr));
      if (occlusion.width !== width || occlusion.height !== height) {
        occlusion.width = width;
        occlusion.height = height;
      }

      const ctx = occlusion.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, metrics.sw, metrics.sh);

      const p = (index) => pointOnStage(landmarks[index], metrics);
      const nose = p(0);
      const leftEar = p(7);
      const rightEar = p(8);
      const leftMouthPoint = p(9);
      const rightMouthPoint = p(10);
      const leftShoulderPoint = p(11);
      const rightShoulderPoint = p(12);
      const leftElbow = p(13);
      const rightElbow = p(14);
      const leftWrist = p(15);
      const rightWrist = p(16);
      const leftIndex = p(19);
      const rightIndex = p(20);

      const headRadius = clamp(shoulderSpanPx * 0.34, 34, 105);
      const handRadius = clamp(shoulderSpanPx * 0.072, 8, 22);
      const forearmRadius = clamp(shoulderSpanPx * 0.060, 7, 19);
      const upperArmRadius = clamp(shoulderSpanPx * 0.074, 8, 22);
      const earMid = { x: (leftEar.x + rightEar.x) / 2, y: (leftEar.y + rightEar.y) / 2 };
      const head = { x: lerp(nose.x, earMid.x, 0.65), y: lerp(nose.y, earMid.y, 0.65) };

      const torsoDepth = (
        Number(landmarks[11]?.z || 0) +
        Number(landmarks[12]?.z || 0) +
        Number(landmarks[23]?.z || 0) +
        Number(landmarks[24]?.z || 0)
      ) / 4;
      const isInFront = (...indices) => {
        const valid = indices
          .map((index) => Number(landmarks[index]?.z))
          .filter((value) => Number.isFinite(value));
        if (!valid.length) return true;
        const averageDepth = valid.reduce((sum, value) => sum + value, 0) / valid.length;
        return averageDepth <= torsoDepth + 0.035;
      };
      const leftHandInFront = isInFront(15, 19);
      const rightHandInFront = isInFront(16, 20);
      const leftForearmInFront = isInFront(13, 15);
      const rightForearmInFront = isInFront(14, 16);
      const leftUpperArmInFront = isInFront(11, 13);
      const rightUpperArmInFront = isInFront(12, 14);

      ctx.save();
      ctx.beginPath();
      addCircle(ctx, head, headRadius);
      if (leftHandInFront) {
        addCircle(ctx, leftWrist, handRadius);
        addCircle(ctx, leftIndex, handRadius * 0.62);
      }
      if (rightHandInFront) {
        addCircle(ctx, rightWrist, handRadius);
        addCircle(ctx, rightIndex, handRadius * 0.62);
      }

      if (mode !== 'bottom') {
        const mouthCenter = {
          x: (leftMouthPoint.x + rightMouthPoint.x) / 2,
          y: (leftMouthPoint.y + rightMouthPoint.y) / 2
        };
        const shoulderCenter = {
          x: (leftShoulderPoint.x + rightShoulderPoint.x) / 2,
          y: (leftShoulderPoint.y + rightShoulderPoint.y) / 2
        };
        const neckTop = {
          x: lerp(mouthCenter.x, shoulderCenter.x, 0.34),
          y: lerp(mouthCenter.y, shoulderCenter.y, 0.34)
        };
        const neckBottomY = shoulderCenter.y - shoulderSpanPx * 0.105;
        const topHalf = shoulderSpanPx * 0.060;
        const bottomHalf = shoulderSpanPx * 0.068;
        const neckCenterX = lerp(neckTop.x, shoulderCenter.x, 0.34);

        ctx.moveTo(neckTop.x - topHalf, neckTop.y);
        ctx.quadraticCurveTo(
          neckCenterX - bottomHalf,
          lerp(neckTop.y, neckBottomY, 0.62),
          neckCenterX - bottomHalf,
          neckBottomY
        );
        ctx.lineTo(neckCenterX + bottomHalf, neckBottomY);
        ctx.quadraticCurveTo(
          neckCenterX + bottomHalf,
          lerp(neckTop.y, neckBottomY, 0.62),
          neckTop.x + topHalf,
          neckTop.y
        );
        ctx.closePath();
      }

      if (mode !== 'bottom') {
        if (sleeveType === 'sleeveless') {
          if (leftUpperArmInFront) addThickSegment(ctx, leftShoulderPoint, leftElbow, upperArmRadius);
          if (rightUpperArmInFront) addThickSegment(ctx, rightShoulderPoint, rightElbow, upperArmRadius);
          if (leftForearmInFront) addThickSegment(ctx, leftElbow, leftWrist, forearmRadius);
          if (rightForearmInFront) addThickSegment(ctx, rightElbow, rightWrist, forearmRadius);
        } else if (sleeveType === 'short') {
          const sleeveCoverage =
            /cap sleeve/.test(garmentText) ? 0.36 :
            /elbow sleeve/.test(garmentText) ? 0.78 :
            /oversized|drop shoulder/.test(garmentText) ? 0.66 :
            0.56;
          const leftSleeveEnd = {
            x: lerp(leftShoulderPoint.x, leftElbow.x, sleeveCoverage),
            y: lerp(leftShoulderPoint.y, leftElbow.y, sleeveCoverage)
          };
          const rightSleeveEnd = {
            x: lerp(rightShoulderPoint.x, rightElbow.x, sleeveCoverage),
            y: lerp(rightShoulderPoint.y, rightElbow.y, sleeveCoverage)
          };
          if (leftUpperArmInFront) addThickSegment(ctx, leftSleeveEnd, leftElbow, upperArmRadius * 0.92);
          if (rightUpperArmInFront) addThickSegment(ctx, rightSleeveEnd, rightElbow, upperArmRadius * 0.92);
          if (leftForearmInFront) addThickSegment(ctx, leftElbow, leftWrist, forearmRadius);
          if (rightForearmInFront) addThickSegment(ctx, rightElbow, rightWrist, forearmRadius);
        }
      }

      ctx.clip();
      drawCameraIntoCurrentClip(ctx, metrics);
      ctx.restore();
    };

    const trackBody = async () => {
      if (!bodyLockEnabled || !poseLandmarker || !video.videoWidth) {
        trackingFrame = requestAnimationFrame(trackBody);
        return;
      }

      if (video.currentTime !== lastVideoTime) {
        lastVideoTime = video.currentTime;

        try {
          const result = poseLandmarker.detectForVideo(video, performance.now());
          const landmarks = result.landmarks && result.landmarks[0];

          if (landmarks) {
            const metrics = coverMetrics();
            const ps = (index) => filteredBodyPoint(index, landmarks[index], metrics);
            const leftShoulder = ps(11);
            const rightShoulder = ps(12);
            const leftElbow = ps(13);
            const rightElbow = ps(14);
            const leftMouth = ps(9);
            const rightMouth = ps(10);
            const leftHip = ps(23);
            const rightHip = ps(24);
            const leftKnee = ps(25);
            const rightKnee = ps(26);
            const leftAnkle = ps(27);
            const rightAnkle = ps(28);

            const rawLeftShoulder = landmarks[11];
            const rawRightShoulder = landmarks[12];
            const rawLeftHip = landmarks[23];
            const rawRightHip = landmarks[24];
            const rawLeftKnee = landmarks[25];
            const rawRightKnee = landmarks[26];
            const rawLeftAnkle = landmarks[27];
            const rawRightAnkle = landmarks[28];

            const shoulderConfidence = Math.min(
              rawLeftShoulder?.visibility ?? 0,
              rawRightShoulder?.visibility ?? 0
            );
            const hipConfidence = Math.min(
              rawLeftHip?.visibility ?? 0,
              rawRightHip?.visibility ?? 0
            );
            const kneeConfidence = Math.min(
              rawLeftKnee?.visibility ?? 0,
              rawRightKnee?.visibility ?? 0
            );
            const ankleConfidence = Math.min(
              rawLeftAnkle?.visibility ?? 0,
              rawRightAnkle?.visibility ?? 0
            );
            const bottomVisible =
              rawLeftHip && rawRightHip && rawLeftKnee && rawRightKnee &&
              hipConfidence > 0.46 &&
              kneeConfidence > 0.40 &&
              (bottomType !== 'pants' || ankleConfidence > 0.30);
            const upperVisible =
              rawLeftShoulder && rawRightShoulder && rawLeftHip && rawRightHip &&
              shoulderConfidence > 0.58 &&
              hipConfidence > 0.48;
            const visible = mode === 'bottom' ? bottomVisible : upperVisible;

            if (visible) {
              const shoulderCenter = {
                x: (leftShoulder.x + rightShoulder.x) / 2,
                y: (leftShoulder.y + rightShoulder.y) / 2
              };
              const hipCenter = {
                x: (leftHip.x + rightHip.x) / 2,
                y: (leftHip.y + rightHip.y) / 2
              };
              const kneeCenter = {
                x: (leftKnee.x + rightKnee.x) / 2,
                y: (leftKnee.y + rightKnee.y) / 2
              };

              const shoulderSpanPx = Math.hypot(
                rightShoulder.x - leftShoulder.x,
                rightShoulder.y - leftShoulder.y
              );
              const hipSpanPx = Math.hypot(
                rightHip.x - leftHip.x,
                rightHip.y - leftHip.y
              );
              const torsoLengthPx = Math.hypot(
                hipCenter.x - shoulderCenter.x,
                hipCenter.y - shoulderCenter.y
              );

              const hipsAreBelowShoulders =
                hipCenter.y > shoulderCenter.y + Math.max(18, shoulderSpanPx * 0.18);
              const plausibleShoulderSpan =
                shoulderSpanPx > metrics.sw * 0.08 && shoulderSpanPx < metrics.sw * 0.78;
              const plausibleTorsoLength =
                torsoLengthPx > shoulderSpanPx * 0.32 && torsoLengthPx < shoulderSpanPx * 2.8;
              const plausibleHipSpan =
                hipSpanPx > metrics.sw * 0.07 && hipSpanPx < metrics.sw * 0.72;
              const kneesBelowHips =
                kneeCenter.y > hipCenter.y + Math.max(16, hipSpanPx * 0.18);
              const geometryLooksPlausible =
                mode === 'bottom'
                  ? plausibleHipSpan && kneesBelowHips
                  : hipsAreBelowShoulders && plausibleShoulderSpan && plausibleTorsoLength;

              if (!geometryLooksPlausible) {
                if (hasStableLock && performance.now() - lastStableAt < 900) {
                  status.textContent = 'Body lock holding position…';
                  trackingFrame = requestAnimationFrame(trackBody);
                  return;
                }
                stableFrames = 0;
                hasStableLock = false;
                stage.classList.remove('is-tracking');
                garment.classList.remove('is-tracking');
                clearOcclusion();
                status.textContent = 'Re-centering body lock…';
                trackingFrame = requestAnimationFrame(trackBody);
                return;
              }

              let anchor;
              let baseSpan;
              let stretchReference;

              if (mode === 'bottom') {
                anchor = { x: hipCenter.x, y: lerp(hipCenter.y, kneeCenter.y, 0.43) };
                baseSpan = Math.max(hipSpanPx, shoulderSpanPx * 0.8);
                stretchReference = Math.max(1, Math.hypot(kneeCenter.x - hipCenter.x, kneeCenter.y - hipCenter.y));
              } else if (mode === 'long') {
                anchor = {
                  x: lerp(shoulderCenter.x, hipCenter.x, 0.38),
                  y: lerp(shoulderCenter.y, kneeCenter.y, 0.42)
                };
                baseSpan = Math.max(shoulderSpanPx, hipSpanPx);
                stretchReference = Math.max(1, Math.hypot(kneeCenter.x - shoulderCenter.x, kneeCenter.y - shoulderCenter.y));
              } else {
                anchor = {
                  x: lerp(shoulderCenter.x, hipCenter.x, 0.46),
                  y: lerp(shoulderCenter.y, hipCenter.y, 0.46)
                };
                baseSpan = shoulderSpanPx;
                stretchReference = torsoLengthPx;
              }

              const userScale = Number(scaleInput.value) / 85;
              const shoulderRatio = shoulderSpanPx / metrics.sw;
              const torsoRatio = torsoLengthPx / metrics.sh;
              const proximitySignal = clamp(
                (shoulderRatio / 0.24) * 0.72 + (torsoRatio / 0.30) * 0.28,
                0.55,
                1.65
              );
              let autoDistanceScale = clamp(
                Math.pow(proximitySignal, 0.38),
                0.80,
                1.24
              );

              if (hasStableLock) {
                autoDistanceScale = clamp(
                  autoDistanceScale,
                  lastAutoScale - 0.025,
                  lastAutoScale + 0.025
                );
              }

              if (Math.abs(autoDistanceScale - lastAutoScale) < 0.008) {
                autoDistanceScale = lastAutoScale;
              }

              lastAutoScale = autoDistanceScale;
              smoothAutoScale = lerp(
                smoothAutoScale,
                autoDistanceScale,
                hasStableLock ? 0.07 : 0.16
              );

              if (mode === 'bottom') {
                clearGarmentMesh();
                const now = performance.now();
                stableFrames += 1;
                hasStableLock = stableFrames >= 3;
                lastStableAt = now;

                renderBottomRig({
                  leftHip,
                  rightHip,
                  leftKnee,
                  rightKnee,
                  leftAnkle,
                  rightAnkle,
                  hipSpanPx,
                  userScale
                });

                stage.classList.add('is-tracking');
                garment.classList.add('is-tracking');
                occlusion.style.display = '';
                renderBottomOcclusion(landmarks, hipSpanPx);
                status.textContent =
                  bottomType === 'skirt'
                    ? 'Body recognized. Skirt locked to your waist and lower body.'
                    : bottomType === 'shorts'
                      ? 'Body recognized. Shorts locked to your waist and thighs.'
                      : 'Body recognized. Pants locked to your waist and tracking each leg.';
                trackingFrame = requestAnimationFrame(trackBody);
                return;
              }

              setBottomRigVisible(false);
              occlusion.style.display = '';

              const widthScale = Number(widthInput.value) / 100;
              const shoulderSpanForTop = Math.hypot(
                rightShoulder.x - leftShoulder.x,
                rightShoulder.y - leftShoulder.y
              );
              const hipSpanForTop = Math.hypot(
                rightHip.x - leftHip.x,
                rightHip.y - leftHip.y
              );
              const torsoWidthForTop = shoulderSpanForTop * 0.72 + hipSpanForTop * 0.28;
              const topSilhouetteFactor =
                /oversized|boxy/.test(garmentText) ? 1.94 :
                /relaxed|loose/.test(garmentText) ? 1.86 :
                /slim|fitted|baby tee|compression/.test(garmentText) ? 1.60 :
                /crop top|cropped/.test(garmentText) ? 1.64 :
                garmentClass === 'outerwear'
                  ? (/trench|overcoat|parka/.test(garmentText) ? 1.98 : 1.92) :
                garmentClass === 'layer'
                  ? (/chunky|cable knit|heavyweight/.test(garmentText) ? 1.90 : 1.84) :
                garmentClass === 'sleeveless-top' ? 1.64 :
                /button[- ]?(up|down)|blouse/.test(garmentText) ? 1.76 :
                /tee\b|t-shirt|t shirt|polo\b/.test(garmentText) ? 1.72 :
                1.78;
              const geometryWidthCorrection = garmentGeometry
                ? clamp(1 / Math.max(0.72, garmentGeometry.shoulderWidthRatio), 0.94, 1.12)
                : 1;
              const diversityWidthCorrection = diversityChest
                ? clamp(0.96 + (diversityChest - 39) * 0.004, 0.90, 1.10)
                : 1;
              const teeBodyWidthFactor =
                /tee\b|t-shirt|t shirt|polo\b/.test(garmentText)
                  ? (
                      /oversized|boxy/.test(garmentText) ? 1.86 :
                      /slim|fitted|baby tee/.test(garmentText) ? 1.56 :
                      1.68
                    )
                  : topSilhouetteFactor;
              const targetWidthPx =
                (mode === 'bottom'
                  ? baseSpan * 1.55 * userScale * smoothAutoScale
                  : mode === 'long'
                    ? torsoWidthForTop * 1.76 * userScale * smoothAutoScale
                    : torsoWidthForTop * teeBodyWidthFactor * userScale * smoothAutoScale) *
                widthScale *
                (mode === 'bottom' ? 1 : geometryWidthCorrection) *
                (mode === 'top' ? diversityWidthCorrection : 1);

              let targetWidth = clamp((targetWidthPx / metrics.sw) * 100, 28, 98);
              let targetX = clamp((anchor.x / metrics.sw) * 100 + Number(xInput.value), 5, 95);
              let targetY = clamp((anchor.y / metrics.sh) * 100 + Number(yInput.value) - (mode === 'top' ? 1.35 : mode === 'long' ? 0.9 : 0), 10, 90);

              if (mode !== 'bottom') {
                const mouthCenter = {
                  x: (leftMouth.x + rightMouth.x) / 2,
                  y: (leftMouth.y + rightMouth.y) / 2
                };
                const faceLooksUsable =
                  Number.isFinite(mouthCenter.x) &&
                  Number.isFinite(mouthCenter.y) &&
                  mouthCenter.y < shoulderCenter.y;

                const neckCenter = {
                  x: faceLooksUsable
                    ? lerp(shoulderCenter.x, mouthCenter.x, 0.14)
                    : shoulderCenter.x,
                  y: faceLooksUsable
                    ? lerp(shoulderCenter.y, mouthCenter.y, 0.20)
                    : shoulderCenter.y - shoulderSpanPx * 0.08
                };

                const naturalAspect =
                  garment.naturalWidth > 0
                    ? garment.naturalHeight / garment.naturalWidth
                    : 1.15;
                const shoulderCenterForLength = {
                  x: (leftShoulder.x + rightShoulder.x) / 2,
                  y: (leftShoulder.y + rightShoulder.y) / 2
                };
                const hipCenterForLength = {
                  x: (leftHip.x + rightHip.x) / 2,
                  y: (leftHip.y + rightHip.y) / 2
                };
                const torsoLengthPx = Math.hypot(
                  hipCenterForLength.x - shoulderCenterForLength.x,
                  hipCenterForLength.y - shoulderCenterForLength.y
                );
                const garmentLengthFactor =
                  garmentClass === 'one-piece'
                    ? (/romper/.test(garmentText) ? 1.62 : 2.58) :
                  garmentClass === 'dress'
                    ? (/mini\b/.test(garmentText) ? 1.78 : /midi\b/.test(garmentText) ? 2.12 : /maxi\b|gown/.test(garmentText) ? 2.55 : 2.18) :
                  /crop|cropped|baby tee/.test(garmentText) ? 0.92 :
                  garmentClass === 'outerwear'
                    ? (/trench|overcoat|long coat/.test(garmentText) ? 1.88 : /cropped/.test(garmentText) ? 1.18 : 1.56) :
                  garmentClass === 'layer'
                    ? (/cropped/.test(garmentText) ? 1.14 : 1.48) :
                  garmentClass === 'sleeveless-top' ? 1.30 :
                  /tee\b|t-shirt|t shirt|polo\b/.test(garmentText) ? 1.34 :
                  /button[- ]?(up|down)|blouse/.test(garmentText) ? 1.42 :
                  1.40;
                const bodyDrivenHeightPx = torsoLengthPx * garmentLengthFactor * userScale * smoothAutoScale;
                const aspectDrivenHeightPx = targetWidthPx * naturalAspect;
                const estimatedGarmentHeightPx = Math.min(
                  metrics.sh * 0.90,
                  bodyDrivenHeightPx * 0.78 + aspectDrivenHeightPx * 0.22
                );
                const collarDepthRatio =
                  /mock neck|turtleneck|high neck/.test(garmentText) ? 0.12 :
                  garmentClass === 'sleeveless-top' ? 0.20 :
                  garmentClass === 'outerwear' ? 0.16 :
                  garmentClass === 'layer' ? 0.17 :
                  garmentClass === 'dress' || garmentClass === 'one-piece' ? 0.18 :
                  0.19;

                const collarTargetY = neckCenter.y + shoulderSpanPx * 0.035;
                const detectedShoulderRatio = garmentGeometry
                  ? clamp(garmentGeometry.shoulderYRatio, 0.06, 0.30)
                  : collarDepthRatio;
                const anchorDepthRatio =
                  garmentClass === 'outerwear'
                    ? lerp(collarDepthRatio, detectedShoulderRatio, 0.62)
                    : garmentClass === 'layer'
                      ? lerp(collarDepthRatio, detectedShoulderRatio, 0.52)
                      : lerp(collarDepthRatio, detectedShoulderRatio, 0.38);
                const centeredGarmentY =
                  collarTargetY +
                  estimatedGarmentHeightPx * (0.5 - anchorDepthRatio);

                targetX = clamp(
                  (neckCenter.x / metrics.sw) * 100 + Number(xInput.value),
                  5,
                  95
                );
                const geometrySeatCorrection = garmentGeometry
                  ? clamp((garmentGeometry.shoulderYRatio - 0.16) * estimatedGarmentHeightPx, -shoulderSpanPx * 0.055, shoulderSpanPx * 0.055)
                  : 0;
                const shoulderSeatLiftPx =
                  mode === 'top'
                    ? shoulderSpanPx * (
                        /tee\b|t-shirt|t shirt|polo\b/.test(garmentText)
                          ? (/oversized|drop shoulder/.test(garmentText) ? 0.071 : 0.082)
                          : 0.068
                      ) + geometrySeatCorrection
                    : shoulderSpanPx * 0.045 + geometrySeatCorrection * 0.55;
                targetY = clamp(
                  ((centeredGarmentY - shoulderSeatLiftPx) / metrics.sh) * 100 + Number(yInput.value),
                  10,
                  90
                );
              }
              const hipCenterForRegistration = {
                x: (leftHip.x + rightHip.x) / 2,
                y: (leftHip.y + rightHip.y) / 2
              };
              const shoulderCenterForRegistration = {
                x: (leftShoulder.x + rightShoulder.x) / 2,
                y: (leftShoulder.y + rightShoulder.y) / 2
              };
              const torsoCenterlineX = lerp(
                shoulderCenterForRegistration.x,
                hipCenterForRegistration.x,
                mode === 'long' ? 0.38 : 0.28
              );
              const torsoCenterCorrection = clamp(
                ((torsoCenterlineX / metrics.sw) * 100) - targetX,
                -2.0,
                2.0
              );
              const centerlineWeight =
                garmentClass === 'outerwear' ? 0.62 :
                garmentClass === 'layer' ? 0.58 :
                mode === 'long' ? 0.60 :
                0.56;
              targetX = clamp(targetX + torsoCenterCorrection * centerlineWeight, 5, 95);

              const shoulderAngleRaw = normalizedBodyAngle(
                Math.atan2(
                  rightShoulder.y - leftShoulder.y,
                  rightShoulder.x - leftShoulder.x
                ) * 180 / Math.PI
              );
              const hipAngleRaw = normalizedBodyAngle(
                Math.atan2(
                  rightHip.y - leftHip.y,
                  rightHip.x - leftHip.x
                ) * 180 / Math.PI
              );
              let shoulderAngle = clamp(
                shoulderAngleRaw * 0.72 + hipAngleRaw * 0.28,
                -10,
                10
              );
              const leftShoulderDepth = Number(landmarks[11]?.z || 0);
              const rightShoulderDepth = Number(landmarks[12]?.z || 0);
              const yawSignal = clamp((rightShoulderDepth - leftShoulderDepth) * 2.4, -0.22, 0.22);
              const perspectiveScaleX = clamp(1 - Math.abs(yawSignal) * 0.72, 0.84, 1);
              const torsoPlaneOffset = clamp(
                (hipCenterForRegistration.x - shoulderCenterForRegistration.x) / Math.max(1, shoulderSpanForTop),
                -0.22,
                0.22
              );
              const torsoSkewDeg = clamp(
                torsoPlaneOffset * 9 + yawSignal * 10,
                -4.5,
                4.5
              );
              const yawShiftPct = yawSignal * (
                garmentClass === 'outerwear' ? 2.2 :
                mode === 'long' ? 1.8 :
                1.45
              );
              targetX = clamp(targetX + yawShiftPct, 5, 95);

              const expectedLength = Math.max(
                1,
                baseSpan * (mode === 'long' ? 2.45 : mode === 'bottom' ? 1.65 : 1.45)
              );
              let targetStretch = clamp(stretchReference / expectedLength, 0.84, 1.22);
              if (mode === 'top') {
                const shoulderMidForStretch = {
                  x: (leftShoulder.x + rightShoulder.x) / 2,
                  y: (leftShoulder.y + rightShoulder.y) / 2
                };
                const hipMidForStretch = {
                  x: (leftHip.x + rightHip.x) / 2,
                  y: (leftHip.y + rightHip.y) / 2
                };
                const torsoLengthForStretch = Math.hypot(
                  hipMidForStretch.x - shoulderMidForStretch.x,
                  hipMidForStretch.y - shoulderMidForStretch.y
                );
                const displayedNaturalHeight = Math.max(
                  1,
                  targetWidthPx * (
                    garment.naturalWidth > 0
                      ? garment.naturalHeight / garment.naturalWidth
                      : 1.15
                  )
                );
                const desiredTopLength =
                  torsoLengthForStretch * (
                    /crop|cropped|baby tee/.test(garmentText) ? 0.92 :
                    garmentClass === 'outerwear' ? 1.54 :
                    garmentClass === 'layer' ? 1.47 :
                    garmentClass === 'sleeveless-top' ? 1.30 :
                    /tee\b|t-shirt|t shirt|polo\b/.test(garmentText)
                      ? (/longline/.test(garmentText) ? 1.42 : 1.31) :
                    1.42
                  ) * userScale * smoothAutoScale;
                targetStretch = clamp(desiredTopLength / displayedNaturalHeight, 0.72, 1.30);
              }

              const now = performance.now();
              const confidence = Math.min(shoulderConfidence, hipConfidence);
              const geometryConfidence =
                garmentGeometry && garmentAlphaBounds
                  ? clamp(
                      0.58 +
                      garmentAlphaBounds.width * 0.18 +
                      garmentAlphaBounds.height * 0.14 +
                      (garmentGeometry.shoulderWidthRatio > 0.58 ? 0.10 : 0),
                      0.58,
                      0.96
                    )
                  : 0.62;
              const effectiveConfidence = Math.min(confidence, geometryConfidence + 0.08);

              frameHistory.push({
                x: targetX,
                y: targetY,
                width: targetWidth,
                angle: shoulderAngle,
                stretch: targetStretch
              });
              if (frameHistory.length > HISTORY_SIZE) frameHistory.shift();

              if (frameHistory.length >= 3) {
                targetX = median(frameHistory.map((frame) => frame.x));
                targetY = median(frameHistory.map((frame) => frame.y));
                targetWidth = median(frameHistory.map((frame) => frame.width));
                shoulderAngle = median(frameHistory.map((frame) => frame.angle));
                targetStretch = median(frameHistory.map((frame) => frame.stretch));
              }

              const topLock = mode === 'top';
              const maxMove = topLock
                ? (effectiveConfidence > 0.78 ? 1.02 : 0.68)
                : (effectiveConfidence > 0.78 ? 1.45 : 0.92);
              const maxWidthMove = topLock
                ? (effectiveConfidence > 0.78 ? 1.00 : 0.68)
                : (effectiveConfidence > 0.78 ? 1.62 : 1.02);
              const maxAngleMove = topLock
                ? (effectiveConfidence > 0.78 ? 0.82 : 0.54)
                : (effectiveConfidence > 0.78 ? 1.8 : 1.0);
              const maxStretchMove = topLock
                ? (effectiveConfidence > 0.78 ? 0.016 : 0.010)
                : (effectiveConfidence > 0.78 ? 0.024 : 0.014);

              if (hasStableLock) {
                targetX = clamp(targetX, lastTargetX - maxMove, lastTargetX + maxMove);
                targetY = clamp(targetY, lastTargetY - maxMove, lastTargetY + maxMove);
                targetWidth = clamp(targetWidth, lastTargetWidth - maxWidthMove, lastTargetWidth + maxWidthMove);
                shoulderAngle = clamp(shoulderAngle, lastTargetAngle - maxAngleMove, lastTargetAngle + maxAngleMove);
                targetStretch = clamp(targetStretch, lastTargetStretch - maxStretchMove, lastTargetStretch + maxStretchMove);
              }

              shoulderAngle = clamp(
                shoulderAngle,
                mode === 'top' ? -6 : -14,
                mode === 'top' ? 6 : 14
              );

              const deadZone = (value, previous, zone) =>
                Math.abs(value - previous) < zone ? previous : value;

              targetX = deadZone(targetX, lastTargetX, mode === 'top' ? 0.34 : 0.32);
              targetY = deadZone(targetY, lastTargetY, mode === 'top' ? 0.34 : 0.32);
              targetWidth = deadZone(targetWidth, lastTargetWidth, mode === 'top' ? 0.62 : 0.45);
              shoulderAngle = deadZone(shoulderAngle, lastTargetAngle, mode === 'top' ? 0.72 : 0.55);
              targetStretch = deadZone(targetStretch, lastTargetStretch, mode === 'top' ? 0.016 : 0.012);

              lastTargetX = targetX;
              lastTargetY = targetY;
              lastTargetWidth = targetWidth;
              lastTargetAngle = shoulderAngle;
              lastTargetStretch = targetStretch;
              lastStableAt = now;
              stableFrames += 1;
              hasStableLock = stableFrames >= 3;

              const translationDelta = Math.hypot(
                targetX - smoothX,
                targetY - smoothY
              );
              const widthDelta = Math.abs(targetWidth - smoothWidth);
              const angleDelta = Math.abs(shoulderAngle - smoothAngle);
              const positionEase = translationDelta > 2.4
                ? 0.46
                : translationDelta > 0.9
                  ? 0.34
                  : hasStableLock ? 0.24 : 0.36;
              const sizeEase = widthDelta > 2.2
                ? 0.30
                : widthDelta > 0.8
                  ? 0.20
                  : hasStableLock ? 0.13 : 0.24;
              const angleEase = angleDelta > 2.2
                ? 0.28
                : angleDelta > 0.8
                  ? 0.18
                  : hasStableLock ? 0.11 : 0.20;
              const stretchEase = hasStableLock ? 0.11 : 0.20;

              smoothX = lerp(smoothX, targetX, positionEase);
              smoothY = lerp(smoothY, targetY, positionEase);
              smoothWidth = lerp(smoothWidth, targetWidth, sizeEase);
              smoothAngle = lerp(smoothAngle, shoulderAngle, angleEase);
              smoothStretch = lerp(smoothStretch, targetStretch, stretchEase);

              if (mode === 'long' && (garmentClass === 'dress' || garmentClass === 'one-piece')) {
                const kneeCenterForDress = {
                  x: (leftKnee.x + rightKnee.x) / 2,
                  y: (leftKnee.y + rightKnee.y) / 2
                };
                const ankleCenterForDress = {
                  x: (leftAnkle.x + rightAnkle.x) / 2,
                  y: (leftAnkle.y + rightAnkle.y) / 2
                };
                const shoulderCenterForDress = {
                  x: (leftShoulder.x + rightShoulder.x) / 2,
                  y: (leftShoulder.y + rightShoulder.y) / 2
                };
                const hipCenterForDress = {
                  x: (leftHip.x + rightHip.x) / 2,
                  y: (leftHip.y + rightHip.y) / 2
                };
                const torsoLengthForDress = Math.hypot(
                  hipCenterForDress.x - shoulderCenterForDress.x,
                  hipCenterForDress.y - shoulderCenterForDress.y
                );
                const shoulderWidthForDress = Math.hypot(
                  rightShoulder.x - leftShoulder.x,
                  rightShoulder.y - leftShoulder.y
                );
                const hipWidthForDress = Math.hypot(
                  rightHip.x - leftHip.x,
                  rightHip.y - leftHip.y
                );
                const miniBottomY = kneeCenterForDress.y - torsoLengthForDress * 0.08;
                const midiBottomY = lerp(kneeCenterForDress.y, ankleCenterForDress.y, 0.58);
                const maxiBottomY = ankleCenterForDress.y - shoulderWidthForDress * 0.04;
                const desiredBottomY =
                  garmentClass === 'one-piece'
                    ? (/romper/.test(garmentText)
                        ? lerp(hipCenterForDress.y, kneeCenterForDress.y, 0.58)
                        : ankleCenterForDress.y - shoulderWidthForDress * 0.04)
                    : /maxi\b|gown/.test(garmentText) ? maxiBottomY :
                      /midi\b/.test(garmentText) ? midiBottomY :
                      /mini\b/.test(garmentText) ? miniBottomY :
                      lerp(kneeCenterForDress.y, ankleCenterForDress.y, 0.18);
                const desiredVisibleHeight = Math.max(
                  torsoLengthForDress * 1.45,
                  desiredBottomY - shoulderCenterForDress.y
                ) * userScale * smoothAutoScale;
                const silhouetteWidthFactor =
                  garmentClass === 'one-piece'
                    ? (/wide[- ]?leg|palazzo/.test(garmentText) ? 1.20 : /romper/.test(garmentText) ? 1.10 : 1.08) :
                  /bodycon|fitted|sheath/.test(garmentText) ? 1.04 :
                  /a-line|aline|skater|fit and flare|fit & flare/.test(garmentText) ? 1.28 :
                  /gown|maxi/.test(garmentText) ? 1.22 :
                  1.16;
                const desiredVisibleWidth = Math.max(
                  shoulderWidthForDress * 1.08,
                  hipWidthForDress * silhouetteWidthFactor
                ) * userScale * smoothAutoScale * widthScale;
                const alphaWidth = garmentAlphaBounds ? Math.max(0.18, garmentAlphaBounds.width) : 1;
                const alphaHeight = garmentAlphaBounds ? Math.max(0.18, garmentAlphaBounds.height) : 1;
                const renderedBoxWidth = desiredVisibleWidth / alphaWidth;
                const renderedBoxHeight = desiredVisibleHeight / alphaHeight;
                const visibleTopOffset = garmentAlphaBounds ? garmentAlphaBounds.top * renderedBoxHeight : 0;
                const visibleCenterOffset = garmentAlphaBounds
                  ? (garmentAlphaBounds.left + garmentAlphaBounds.width / 2 - 0.5) * renderedBoxWidth
                  : 0;
                const dressTopY = shoulderCenterForDress.y - shoulderWidthForDress * 0.10;
                const dressCenterX = lerp(shoulderCenterForDress.x, hipCenterForDress.x, 0.34);
                garment.style.left = `${dressCenterX - visibleCenterOffset}px`;
                garment.style.top = `${dressTopY - visibleTopOffset}px`;
                garment.style.width = `${Math.max(1, renderedBoxWidth)}px`;
                garment.style.height = `${Math.max(1, renderedBoxHeight)}px`;
                garment.style.objectFit = 'fill';
                garment.style.transformOrigin = '50% 16%';
                garment.style.transform =
                  `translateX(-50%) rotate(${smoothAngle.toFixed(2)}deg) skewX(${torsoSkewDeg.toFixed(2)}deg) scaleX(${perspectiveScaleX.toFixed(3)})`;
              } else {
                garment.style.height = 'auto';
                garment.style.objectFit = '';
                garment.style.transformOrigin = '';
                garment.style.left = `${smoothX}%`;
                garment.style.top = `${smoothY}%`;
                garment.style.width = `${smoothWidth}%`;
                garment.style.transform =
                  `translate(-50%, -50%) rotate(${smoothAngle.toFixed(2)}deg) skewX(${torsoSkewDeg.toFixed(2)}deg) scaleX(${perspectiveScaleX.toFixed(3)}) scaleY(${smoothStretch.toFixed(3)})`;
              }

              if (mode === 'top' && /tee\b|t-shirt|t shirt|polo\b/.test(garmentText)) {
                renderTeeMesh({
                  leftShoulder,
                  rightShoulder,
                  leftElbow,
                  rightElbow,
                  leftHip,
                  rightHip,
                  shoulderSpanPx,
                  hipSpanPx: hipSpanForTop,
                  userScale,
                  yawSignal,
                  neckCenter
                });
              } else {
                clearGarmentMesh();
              }

              const torsoBounds = {
                left: Math.min(leftShoulder.x, leftHip.x, rightShoulder.x, rightHip.x) - shoulderSpanPx * 0.12,
                right: Math.max(leftShoulder.x, leftHip.x, rightShoulder.x, rightHip.x) + shoulderSpanPx * 0.12,
                top: Math.min(leftShoulder.y, rightShoulder.y) - shoulderSpanPx * 0.08,
                bottom: mode === 'long'
                  ? Math.max(leftKnee.y, rightKnee.y)
                  : Math.max(leftHip.y, rightHip.y) + shoulderSpanPx * 0.16
              };

              renderOcclusion(landmarks, shoulderSpanPx, torsoBounds);

              stage.classList.add('is-tracking');
              garment.classList.add('is-tracking');
              status.textContent =
                mode === 'bottom'
                  ? 'Body recognized. Garment aligned to your hips and legs.'
                  : mode === 'long'
                    ? 'Body recognized. Neckline aligned and garment locked through your body.'
                    : 'Body recognized. Garment locked to your torso with your neck seated inside the collar.';
            } else {
              const now = performance.now();
              if (hasStableLock && now - lastStableAt < 380) {
                stage.classList.add('is-tracking');
                garment.classList.add('is-tracking');
                status.textContent = 'Body lock holding position…';
              } else {
                stableFrames = 0;
                hasStableLock = false;
                stage.classList.remove('is-tracking');
                garment.classList.remove('is-tracking');
                clearOcclusion();
                setBottomRigVisible(false);
                hideBottomParts();
                status.textContent = mode === 'bottom'
                  ? 'Body lock is on. Keep your waist, hips, and legs in view.'
                  : 'Body lock is on. Keep your shoulders and hips in view.';
              }
            }
          } else {
            const now = performance.now();
            if (hasStableLock && now - lastStableAt < 300) {
              stage.classList.add('is-tracking');
              garment.classList.add('is-tracking');
              status.textContent = 'Body lock holding position…';
            } else {
              stableFrames = 0;
              hasStableLock = false;
              stage.classList.remove('is-tracking');
              garment.classList.remove('is-tracking');
              clearOcclusion();
              setBottomRigVisible(false);
              hideBottomParts();
              status.textContent = mode === 'bottom' ? 'Looking for your lower body…' : 'Looking for your body…';
            }
          }
        } catch (error) {
          stage.classList.remove('is-tracking');
          clearOcclusion();
        }
      }

      trackingFrame = requestAnimationFrame(trackBody);
    };

    const startTracking = async () => {
      if (!bodyLockEnabled) return;
      status.textContent = 'Loading enhanced body recognition…';
      const model = await loadPoseModel();
      if (!model || !bodyLockEnabled) return;
      stopTracking();
      status.textContent = 'Body lock is on. Stand with your shoulders and hips visible.';
      trackingFrame = requestAnimationFrame(trackBody);
    };

    const startCamera = async () => {
      stopCamera();
      stopTracking();
      status.textContent = 'Starting camera…';

      try {
        stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: {
            facingMode: { ideal: facingMode },
            width: { ideal: 1280 },
            height: { ideal: 1920 }
          }
        });

        video.srcObject = stream;
        await video.play();
        mirrored = facingMode === 'user';
        updateVideoMirror();

        if (bodyLockEnabled) await startTracking();
        else status.textContent = 'Drag the garment or use the controls to position it.';
      } catch (error) {
        status.textContent = 'Camera access was blocked. Allow camera permission in your browser and try again.';
      }
    };

    openButton.addEventListener('click', async () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      applyManualPosition();
      makeGarmentBackgroundTransparent();
      await startCamera();
    });

    const close = () => {
      stopTracking();
      stopCamera();
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    closeButton.addEventListener('click', close);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    scaleInput.addEventListener('input', () => {
      if (!bodyLockEnabled) applyManualPosition();
    });
    widthInput.addEventListener('input', () => {
      if (!bodyLockEnabled) {
        applyManualPosition();
      } else if (mode === 'bottom' && hasStableLock) {
        lastVideoTime = -1;
      }
    });

    resetButton.addEventListener('click', () => {
      scaleInput.value = root.dataset.defaultScale || '85';
      widthInput.value = '100';
      xInput.value = '0';
      yInput.value = '0';
      smoothStretch = 1;
      if (!bodyLockEnabled) applyManualPosition();
      lastVideoTime = -1;
      status.textContent = bodyLockEnabled ? 'Adjustments reset. Body lock is active.' : 'Adjustments reset.';
    });
    xInput.addEventListener('input', () => {
      if (!bodyLockEnabled) applyManualPosition();
    });
    yInput.addEventListener('input', () => {
      if (!bodyLockEnabled) applyManualPosition();
    });

    lockButton.addEventListener('click', async () => {
      bodyLockEnabled = !bodyLockEnabled;
      lockButton.textContent = bodyLockEnabled ? 'Body lock: On' : 'Body lock: Off';

      if (bodyLockEnabled) {
        await startTracking();
      } else {
        stopTracking();
        applyManualPosition();
        status.textContent = 'Body lock is off. Drag or adjust the garment manually.';
      }
    });

    flipButton.addEventListener('click', () => {
      mirrored = !mirrored;
      updateVideoMirror();
    });

    cameraButton.addEventListener('click', async () => {
      facingMode = facingMode === 'user' ? 'environment' : 'user';
      await startCamera();
    });

    stage.addEventListener('pointerdown', (event) => {
      dragging = true;
      stage.setPointerCapture(event.pointerId);
      dragStart = { x: event.clientX, y: event.clientY };
      dragBase = { x: Number(xInput.value), y: Number(yInput.value) };
    });

    stage.addEventListener('pointermove', (event) => {
      if (!dragging || !dragStart || !dragBase) return;

      const rect = stage.getBoundingClientRect();
      const dx = ((event.clientX - dragStart.x) / rect.width) * 100;
      const dy = ((event.clientY - dragStart.y) / rect.height) * 100;

      xInput.value = clamp(dragBase.x + dx, -30, 30);
      yInput.value = clamp(dragBase.y + dy, -30, 30);

      if (!bodyLockEnabled) applyManualPosition();
    });

    const endDrag = () => { dragging = false; };
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);

    captureButton.addEventListener('click', () => {
      if (!video.videoWidth || !video.videoHeight) {
        status.textContent = 'Camera is not ready yet.';
        return;
      }

      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');

      if (mirrored) {
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
      }

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      if (mirrored) ctx.setTransform(1, 0, 0, 1, 0, 0);

      const stageRect = stage.getBoundingClientRect();
      const garmentRect = garment.getBoundingClientRect();
      const sx = canvas.width / stageRect.width;
      const sy = canvas.height / stageRect.height;

      ctx.globalAlpha = 0.97;
      ctx.drawImage(
        garment,
        (garmentRect.left - stageRect.left) * sx,
        (garmentRect.top - stageRect.top) * sy,
        garmentRect.width * sx,
        garmentRect.height * sy
      );
      ctx.globalAlpha = 1;

      canvas.toBlob((blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'diversity-virtual-try-on.jpg';
        anchor.click();
        setTimeout(() => URL.revokeObjectURL(url), 1500);
        status.textContent = 'Preview saved.';
      }, 'image/jpeg', 0.92);
    });

    applyManualPosition();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
